/**
 * meta.js — client-side caller for the read-only `meta-insights` edge function.
 * The function holds the Meta token server-side; we just pass the ad account + range.
 */
import { supabase } from './supabaseClient';

const FN_SECRET = process.env.REACT_APP_META_FN_SECRET || '';

/**
 * @param {{adAccountId:string, since?:string, until?:string, datePreset?:string}} opts
 * @returns {Promise<object>} { account, window, accountMetrics, campaigns: [...] }
 */
export async function fetchMetaInsights({ adAccountId, since, until, datePreset }) {
  const { data, error } = await supabase.functions.invoke('meta-insights', {
    body: { adAccountId, since, until, datePreset },
    headers: FN_SECRET ? { 'x-fn-secret': FN_SECRET } : {},
  });
  if (error) throw new Error(error.message || 'Meta fetch failed');
  if (data?.error) throw new Error(data.error);
  return data;
}

// Roll campaign rows up into an account-level summary (fallback if account insights empty).
export function summarize(campaigns = []) {
  const t = { spend: 0, impressions: 0, clicks: 0, reach: 0, purchases: 0, leads: 0, messages: 0, value: 0 };
  campaigns.forEach(c => {
    const m = c.metrics; if (!m) return;
    t.spend += m.spend; t.impressions += m.impressions; t.clicks += m.clicks;
    t.reach += m.reach; t.purchases += m.purchases; t.leads += m.leads; t.messages += (m.messages || 0); t.value += m.value;
  });
  t.ctr = t.impressions ? (t.clicks / t.impressions) * 100 : 0;
  t.cpm = t.impressions ? (t.spend / t.impressions) * 1000 : 0;
  t.roas = t.spend ? t.value / t.spend : 0;
  t.cpl = t.leads ? t.spend / t.leads : 0;
  t.costPerMsg = t.messages ? t.spend / t.messages : 0;
  return t;
}
